import { Component } from '@angular/core'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'

const exampleHtml = `
<se-po-household-review
  [child]="child"
  [parent]="parent"
  [guardianInvites]="invites"
  (cancelInvite)="onCancelInvite($event)"
  (continue)="onContinue()"
  (addAnother)="onAddAnother()">
</se-po-household-review>
`

const exampleTypescript = `
export class HouseholdReviewExampleComponent extends SeFeDocsExampleComponent implements OnInit {

  constructor() {
    super()
  }

  public options = {
    guardianInvites: [
      { email: 'dsfasdfa@afadsf.com ', access: 'manager'}
    ],
    child: {
      date_of_birth: '2009-12-31',
      first_name:'Junior',
      gender: 'male',
      last_name: 'Test'
    },
    parent: {
      first_name: 'Natalie',
      last_name: 'Fisher',
      gender: 'female',
      date_of_birth: '1989-12-21',
      email_addresses: [{ address: 'nat.fisher@gmail.com' }],
      // eslint-disable-next-line id-blacklist
      phone_numbers: [{ number: '1234567890' }]
    }
  }

  public ngOnInit(): void {
    //noop
  }
}
`

const template = `<se-fe-docs-example [example]="this">${exampleHtml}</se-fe-docs-example>`

@Component({
  selector: 'se-po-household-review-example',
  template,
  styleUrls: ['../household-review-docs.component.scss'],
  standalone: false,
})
export class HouseholdReviewExampleComponent extends SeFeDocsExampleComponent {
  public invites = [
    { email: 'dsfasdfa@afadsf.com ', access: 'manager'}
  ]
  public child = {
    name: {
      first: 'John',
      last: 'Doe',
    },
    dateOfBirth: '2023-10-01',
    gender: 'male',
    gradYear: '2099'
  }
  public parent = {
    dateOfBirth: '2023-10-01',
    email: 'test@test.com',
    firstName: 'Parent',
    gender: 'male',
    lastName: 'Name',
    phone: '1234567890'
  }

  constructor() {
    super()
  }

  public onCancelInvite($event): void {
    console.log('Canceling Invite for:', $event)
  }

  public onContinue(): void {
    console.log('Continue:')
  }

  public onAddAnother(): void {
    console.log('Add Another')
  }
}
